/* eslint-disable */
export default {
    questionnaires_title_influencing_styles: "Influencing styles",
    questionnaires_title_working_styles: "Working styles",
    questionnaires_title_personality: "Personality",
    questionnaires_title_motives: "Motives",
    questionnaires_title_intellectual_capabilities: "Intellectual capabilities",
    questionnaires_title_home: "Home",
    questionnaires_title_location: "Location",
    questionnaires_title_willen: "Want",
    questionnaires_title_waarden: "Values",
    questionnaires_title_beinvloeding: "Influencing styles",
    questionnaires_title_drijfveren: "Motives",
    questionnaires_title_big5: "Big 5",
    questionnaires_title_werkstijlen: "Working Styles",
    questionnaires_title_verbalAnalogies: "Verbal Analogies",
    questionnaires_title_abstractMatrix: "Abstract Matrix",
    questionnaires_title_numericalAbility: "Numerical",
    questionnaires_title_wpq: "WPQ",
    questionnaires_hour_label: "Hour",
    questionnaires_minutes_label: "Minutes",
    questionnaires_minute_label: "Minute",
    questionnaires_seconds_label: "Seconds",
    questionnaires_second_label: "Second",
    questionnaires_title_verbalAbility: "Verbal",
    questionnaires_title_abstractAbility: "Abstract",
    questionnaires_title_verbalAbilityRetest: "Verbal (retest)",
    questionnaires_title_numericalAbilityRetest: "Numerical (retest)",
    questionnaires_title_abstractAbilityRetest: "Abstract (retest)",
    questionnaires_title_buildingDocks: "Building Docks",
    questionnaires_title_beinvloedingShort: "Influencing styles",
    questionnaires_title_drijfverenShort: "Motives",
    questionnaires_title_big5Short: "Big 5",
    questionnaires_title_werkstijlenShort: "Working Styles",
    questionnaires_title_waardenShort: "Values",
    questionnaires_title_gMAT1: "GMAT",
    questionnaires_title_gMAT: "G-test",
    questionnaires_title_dilemmaTest: "Dilemma test",
    questionnaires_title_wpqShort: "WPQ",
    questionnaires_title_vPI: "Personality (VPI)",
    questionnaires_title_gMatMbo: "G-test (mbo)",
    questionnaires_title_criticalThinking: "Critical thinking",
    questionnaires_title_logicalReasoningGame: "Logical reasoning game",
    questionnaires_title_concentrationGame: "Concentration game",
    questionnaires_title_numericalInsightGame: "Numerical insight game",
    questionnaires_title_simulationGame: "FrenzyFest",
    questionnaires_title_moodGame: "In Good Mood"
};
